import styled, {css} from 'styled-components';
import {NODE_COLOR, NODE_STATE} from './constant';
import {getNodeStyles} from './utils';

export const horizontalGutter = '68px';
export const borderRadiusValue = '10px';

// modify label here
export const iconWidth = '34px';
export const colorBase = '#005eb8';
export const lineBorder = `1px dashed #BEBEBE`;
// export const mLeftFirstNode = '10px';
// export const mTopFirstNode = '10px';
export const getLabelWidth = (isViewMode) => (isViewMode ? '150px' : '34px');
export const getLineHeight = (isViewMode) => (isViewMode ? '167px' : '104px');

export const marginTopFirstEntry = '10px';
export const marginLeftFirstEntry = '22px';

const previewData = {
	paddingTop: '32px',
	marginTop: '32px',
	minHeight: '80px'
};
const previewDataExpanded = {
	paddingTop: '112px',
	marginTop: '112px',
	minHeight: '160px'
};

export const StyledFlowChart = styled.div`
	position: relative;
	height: calc(100% - ${marginTopFirstEntry});
	overflow: auto;
	max-width: 100%;

	${(props) => props.use === 'preview-data' && `padding-top: ${previewData.paddingTop};`}
	${(props) => props.use === 'preview-data-expanded' && `padding-top: ${previewDataExpanded.paddingTop};`}
`;

export const StyledBranch = styled.div`
	position: relative;
	margin-left: ${({isParentNodeIfThen, isSmallSpacing, firstNode, isViewMode}) =>
		isParentNodeIfThen
			? `calc(${horizontalGutter} * ${isSmallSpacing ? 1 : 1.5} + ${getLabelWidth(isViewMode)})`
			: `calc(${horizontalGutter} + ${getLabelWidth(isViewMode)})`};

	&:before {
		content: '';
		width: ${({isParentNodeIfThen, isSmallSpacing}) =>
			isParentNodeIfThen
				? `calc(${horizontalGutter} * ${isSmallSpacing ? 1 : 1.5})`
				: `calc(${horizontalGutter} / 2)`};
		// line: right all nodes
		border-top: ${lineBorder};
		position: absolute;
		left: ${({isParentNodeIfThen, isSmallSpacing}) =>
			isParentNodeIfThen ? `calc(-${horizontalGutter} * ${isSmallSpacing ? 1 : 1.5})` : `-${horizontalGutter}`};
		top: 15px;
		margin-top: 1px;
	}

	&.entry-three {
		&:first-child {
			&:before {
				width: ${borderRadiusValue};
				height: 200%;
				top: 15px;
				margin-top: 2px;
			}
		}
	}
`;

export const IconDelete = styled.i`
	visibility: hidden;
	font-size: 18px !important;
	color: #595959 !important;
	position: absolute;
	top: -9px;
	right: -9px;
`;

export const Text = styled.span`
	font-family: Roboto;
	font-size: 11px;
	line-height: 13px;
	color: #595959;

	position: absolute;
	top: 19px;
	left: 50px;
	z-index: 2;
`;

export const RadioButton = styled.input`
	margin-top: 0.2rem;
	margin-right: 0.5rem;
	cursor: pointer;
`;

export const LabelRadio = styled.label`
	display: block;
	font-size: 14px;
	cursor: pointer;
`;

export const NoData = styled.div`
	margin-left: 14px;

	.wrapper-btn-add {
		background-color: ${colorBase};
		border: none;
		width: 20px;
		height: 20px;
		i {
			color: #fff;
			font-size: 11px;
		}
		&:before {
			content: '';
			position: absolute;
			width: 34px;
			height: 34px;
			border-radius: 50%;
			border: 1px dashed #bebebe;
		}
	}
`;

export const BadgeTotal = styled.span`
	max-width: 92px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const BadgePercent = styled.span`
	height: 14px;
	padding: 0 3px;
	background-color: #cae5fe;
	color: #666;
	border-radius: 50px;

	display: flex;
	align-items: center;
	white-space: nowrap;
`;

export const Badge = styled.div`
	display: flex;
	align-items: center;
	gap: 3px;
	width: fit-content;

	height: 20px;
	padding: 0 3px;
	border: 1px solid #cae5fe;
	border-radius: 50px;
	max-width: ${getLabelWidth(true)};

	${BadgeTotal},${BadgePercent} {
		font-family: Roboto;
		font-size: 10px;
		line-height: 12px;
		color: #666;
	}
`;

export const WrapperPreview = styled.div`
	position: absolute;
	top: calc(${iconWidth} + 6px);
	left: 0;
	z-index: 100;

	${Badge} {
		margin-top: 6px;
	}
`;

export const NodeBorder = styled.div`
	position: absolute;
	/* top: -2px;
	left: -2px; */
	width: ${iconWidth};
	height: ${iconWidth};
	border-radius: 50%;
`;

export const WrapperIcon = styled.div`
	position: relative;
	width: ${iconWidth};
	height: ${iconWidth};
	border-radius: 50%;
	cursor: pointer;

	display: flex;
	align-items: center;
	justify-content: center;

	${({nodeType, customStyles}) => {
		const styles = getNodeStyles({nodeType, status: NODE_STATE.DEFAULT, ...customStyles});
		return css`
			background-color: ${styles.backgroundColor};
			border: ${styles.border};
			i {
				color: ${styles.color};
				font-size: 24px;
			}

			svg {
				color: ${styles.color};
				width: 24px;
				height: 24px;
			}
		`;
	}}

	&:hover {
		transition: opacity 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);

		${({nodeType, customStyles}) => {
			const styles = getNodeStyles({nodeType, status: NODE_STATE.HOVER, ...customStyles});
			return css`
				background-color: ${styles.hoverBackgroundColor};
				border: ${styles.hoverBorder};
				i {
					color: ${styles.hoverColor};
				}

				svg {
					color: ${styles.hoverColor};
				}

				${NodeBorder} {
					top: -1px;
					left: -1px;
					border: ${styles.hoverBorder};
				}
			`;
		}}
	}

	&.active {
		${({nodeType, customStyles}) => {
			const styles = getNodeStyles({nodeType, status: NODE_STATE.ACTIVE, ...customStyles});
			return css`
				background-color: ${styles.activeBackgroundColor};
				color: ${styles.activeColor};
				border: ${styles.activeBorder};
				i {
					color: ${styles.activeColor};
				}

				svg {
					color: ${styles.activeColor};
				}

				${NodeBorder} {
					top: -2px;
					left: -2px;
					border: ${styles.activeBorder};
				}
			`;
		}}
	}

	&.error {
		background-color: ${({nodeType, customStyles}) =>
			getNodeStyles({nodeType, status: NODE_STATE.DEFAULT, ...customStyles}).errorBackgroundColor};

		&:hover {
			${({nodeType, customStyles}) => {
				const styles = getNodeStyles({nodeType, status: NODE_STATE.HOVER, ...customStyles});
				return css`
					border: ${styles.errorHoverBorder};
					i {
						color: ${styles.errorHoverColor};
					}

					svg {
						color: ${styles.errorHoverColor};
					}

					${NodeBorder} {
						top: -1px;
						left: -1px;
						border: ${styles.errorHoverBorder};
					}
				`;
			}}
		}

		&.active {
			${({nodeType, customStyles}) => {
				const styles = getNodeStyles({nodeType, status: NODE_STATE.ACTIVE, ...customStyles});
				return css`
					background-color: ${styles.errorActiveBackgroundColor};
					border: ${styles.errorActiveBorder};
					i {
						color: ${styles.errorActiveColor};
					}

					svg {
						color: ${styles.errorActiveColor};
					}

					${NodeBorder} {
						top: -2px;
						left: -2px;
						border: ${styles.errorActiveBorder};
					}
				`;
			}}
		}
	}
`;

export const Node = styled.div`
	position: absolute;
	left: 0;
	top: 0;
	z-index: 2;
	cursor: pointer;
	background-color: inherit;
	padding: 0 4px;

	/* ${(props) => props.use === 'preview-data' && props.firstNode && `margin-top: ${previewData.marginTop};`}
	${(props) =>
		props.use === 'preview-data-expanded' && props.firstNode && `margin-top: ${previewDataExpanded.marginTop};`} */

	.label-node.disabled {
		&:hover {
			border-color: ${colorBase};
		}
		opacity: 0.3;
		cursor: not-allowed;
	}

	.label-node:hover {
		${IconDelete} {
			visibility: visible;
		}
	}
`;

export const WrapperLabel = styled.div`
	font-family: Roboto;
	font-size: 11px;
	font-weight: 400;
	line-height: 13px;
	color: #595959;
	margin-top: 0;
	margin-bottom: 0;

	position: absolute;
	top: 40px;
	left: ${({isViewMode}) => `calc((${getLabelWidth(isViewMode)} + 10px) / -2)`};
	width: 86px;
	padding: 3px;
	border-radius: 5px;
	text-align: center;

	&.active {
		background-color: ${({nodeType, customStyles}) =>
			getNodeStyles({nodeType, status: NODE_STATE.ACTIVE, ...customStyles}).activeColor};
		color: #fff;
	}

	&.error {
		&.active {
			background-color: ${({customStyles}) =>
				getNodeStyles({nodeType: 'ERROR', status: NODE_STATE.ACTIVE, ...customStyles}).errorActiveColor};
			color: #fff;
		}
	}

	${({isViewMode}) =>
		isViewMode
			? css`
					display: flex;
					align-items: center;
					background-color: #fcfdff;
					padding-right: 4px;
					/* margin-bottom: 3px; */
					max-width: 100px;

					&:after {
						content: '';
						width: 100px;
						border-top: ${lineBorder};
						position: absolute;
						right: 2px;
						top: 15px;
						margin-top: 1px;
						z-index: -1;
					}

					.group-percent {
						margin-left: 2px;
						white-space: nowrap;
					}
				`
			: css``};
`;

export const Label = styled.p`
	margin-top: 0;
	margin-bottom: 0;
	line-height: 1.5em;
	font-size: 11px;
	line-height: 13px;

	${({isViewMode}) =>
		isViewMode
			? css`
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				`
			: css`
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 3;
					-webkit-box-orient: vertical;
				`}
`;

export const WrapperNode = styled.div`
	position: relative;

	${({firstNode}) =>
		firstNode &&
		css`
			margin-top: ${marginTopFirstEntry};
			margin-left: ${marginLeftFirstEntry};
			// TODO: preview
			/* height: 500px; */
		`};

	${({isViewMode}) =>
		isViewMode &&
		css`
			${WrapperLabel} {
				position: unset;
				text-align: left;
				/* width: 100%; */
				width: fit-content;
				-webkit-line-clamp: 2;

				margin-left: 10px;
			}

			${Node} {
				display: flex;
				align-items: center;

				width: ${({isViewMode}) => getLabelWidth(isViewMode)};
			}
		`};
`;

export const StyledEntry = styled.div`
	position: relative;
	min-height: ${({isViewMode}) => getLineHeight(isViewMode)};
	${(props) => props.use === 'preview-data' && `min-height: ${previewData.minHeight};`}
	${(props) => props.use === 'preview-data-expanded' && `min-height: ${previewDataExpanded.minHeight};`}
	&:before {
		content: '';
		height: 100%;
		// line: top of all branches (vertical)
		border-left: ${lineBorder};
		position: absolute;
		left: ${({isBranch, isSmallSpacing}) =>
			isBranch ? `calc(-${horizontalGutter} * ${isSmallSpacing ? 1 : 2} / 2)` : `calc(-${horizontalGutter} / 2)`};
		top: 16px;
	}

	&:after {
		content: '';
		width: ${({isBranch, isSmallSpacing}) =>
			isBranch ? `calc(${horizontalGutter} * ${isSmallSpacing ? 1 : 2} / 2)` : `calc(${horizontalGutter} / 2)`};
		// line: isSmallSpacing ? left node : start of all branches
		border-top: ${lineBorder};
		position: absolute;
		left: ${({isBranch, isSmallSpacing}) =>
			isBranch ? `calc(-${horizontalGutter} * ${isSmallSpacing ? 1 : 2} / 2)` : `calc(-${horizontalGutter} / 2)`};
		top: 15px;
		margin-top: 1px;
	}

	&:first-child {
		&:before {
			width: ${borderRadiusValue};
			height: 100%;
			top: 15px;
			margin-top: 2px;
		}

		&:after {
			height: ${borderRadiusValue};
		}
	}

	&:last-child {
		&:before {
			height: 0;
		}
		&:after {
			content: '';
			height: ${borderRadiusValue};
			border-top: none;
			margin-left: 3px;
			// line: right line of last child (verical + horizontal)
			border-bottom: ${lineBorder};
			margin-top: calc(-${borderRadiusValue} + 1.5px);
		}
	}

	&.flag {
		background-color: inherit;
		padding: 0 4px;

		/* ${WrapperIcon} {
			background-color: ${NODE_COLOR.END.DEFAULT.backgroundColor};

			:hover {
				border: none;
			}
		} */
	}

	&.sole {
		z-index: 0;
		&:before {
			content: none;
		}

		&:after {
			width: calc(${horizontalGutter} / 2);
			height: 0;
			margin-top: 1px;
			border-radius: 0;
			margin-left: 1.5px;
			border-top: none;
		}
	}

	&.end-node {
		width: ${({isViewMode}) => `calc(${horizontalGutter} + ${getLabelWidth(isViewMode)})`};
		position: absolute;
		z-index: 1; // > start-node

		&:hover .btn-add-wrapper {
			visibility: ${({draggingNode}) => (draggingNode ? 'hidden' : 'visible')};
		}

		/* &:hover{} */
	}

	&.sole-copy {
		&:before {
			content: none;
		}
		&:after {
			content: none;
		}
	}

	&.start-node {
		width: ${({isViewMode}) => `calc(${horizontalGutter} + ${getLabelWidth(isViewMode)})`};
		position: absolute;
		left: calc(-${horizontalGutter} * 1.5);

		&:hover .btn-copy-wrapper {
			visibility: ${({draggingNode}) => (draggingNode ? 'hidden' : 'visible')};
		}
	}

	& > div:first-of-type {
		&:hover + .sole-copy {
			&.sole-copy .btn-copy-wrapper {
				visibility: visible;
			}
		}
	}

	.btn-add-wrapper,
	.btn-copy-wrapper {
		visibility: hidden;
		position: absolute;
		top: -12.5px;
		text-align: right;
		z-index: 1;

		&.no-data {
			visibility: visible;
			position: relative;
		}
	}
`;
